import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import Swal from "sweetalert2";

class EstAssoc extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      establecimientos: [],
      nivelUsuario: localStorage.nivel_actual,
    };

    this.removeEst = this.removeEst.bind(this);
    this.asociar = this.asociar.bind(this);
    this.asoForm = {};
  }

  removeEst(e) {
    let est = this.state.establecimientos;

    est[e.target.id] = null;

    const fest = est.filter((el) => {
      return el != null;
    });

    this.setState({
      establecimientos: fest,
    });
  }

  asociar(e) {
    if (this.state.establecimientos.length) {
      Api.loading(1);
      Api.fetch(
        "app/establishmentAssoc",
        { establecimientos: this.state.establecimientos },
        "POST"
      ).then((data) => {
        Swal.fire({
          title: "Asociar establecimiento",
          icon: "success",
          text: data.message,
          confirmButtonText: "Continuar",
        });
        this.setState({ establecimientos: [] });
      }).catch((error) => {
        error.json().then((r) => {
          Swal.fire({
            title: "Error",
            icon: "warning",
            text: r.message,
            confirmButtonText: "Continuar",
          });
        })
      });
    } else {
      Swal.fire({
        title: "Error",
        icon: "warning",
        text: "Ingrese al menos un establecimiento a la lista.",
        confirmButtonText: "Continuar",
      });
    }
  }
  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let asociaFrm = {
      target: "#asociaForm",
      nombre: "asociaForma",
      elementClass: "form-control",
      elements: [
        {
          select: {
            cols: 12,
            name: "establecimiento",
            type: "text",
            label: "Establecimiento <span style=color:red>*</span>",
            render: (me) => {
              let opt = "";
              me.innerHTML = "<option value=''>Cargando...</option>";
              Api.fetch("app/getEstablecimientosRegRep").then((r) => {
                for (let o in r) {
                  opt += `<option value="${r[o].id}">${r[o].razon_social} - [${r[o].folio_establecimiento}]</option>`;
                }
                me.innerHTML = opt;
              });
            },
          },
        },
        {
          input: {
            cols: 8,
            name: "razon_social",
            type: "text",
            label:
              "Razón social establecimiento a asociar <span style=color:red>*</span>",
          },
        },
        {
          input: {
            cols: 3,
            name: "guid",
            type: "text",
            label: "GUID <span style=color:red>*</span>",
            maxlength: 4,
          },
        },
        {
          button: {
            cols: 1,
            name: "asocia",
            label: "",
            text: "",
            class: "form-control btn-primary ",
            icon: "fas fa-plus",
            click: (e) => {
              let datos = this.asoForm.data();
              let est = this.state.establecimientos;
              datos.establecimientoTxt = "";
              let me = this.asoForm.querySelector("#establecimiento");
              if (me.options[me.selectedIndex]) {
                datos.establecimientoTxt =
                  me.options[me.selectedIndex].innerHTML;
              }

              if (
                datos.razon_social === undefined ||
                datos.guid === undefined ||
                datos.establecimientoTxt === ""
              ) {
                Swal.fire({
                  title: "Error",
                  icon: "warning",
                  text: "Todos los campos son requeridos.",
                  confirmButtonText: "Continuar",
                });
                return;
              }

              for (let es in est) {
                if (JSON.stringify(est[es]) === JSON.stringify(datos)) {
                  Swal.fire({
                    title: "Error",
                    icon: "warning",
                    text: "Ya cuenta con esta asociación en la lista.",
                    confirmButtonText: "Continuar",
                  }).then((result) => {
                    this.asoForm.clear();
                  });
                  return;
                }
              }

              Api.loading(1);
              Api.fetch(
                "app/getValidIdEstablishment",
                {
                  id: datos.establecimiento,
                  guid: datos.guid,
                  razon_social: datos.razon_social,
                },
                "POST"
              ).then((data) => {
                Api.loading(0);
                if (data.id) {
                  if (
                    ((data.tipo_establecimiento_id === "4" ||
                      data.tipo_establecimiento_id === "3") &&
                      (this.state.tipo_establecimiento_id === "1" ||
                        this.state.tipo_establecimiento_id === "2")) ||
                    ((data.tipo_establecimiento_id === "1" ||
                      data.tipo_establecimiento_id === "2") &&
                      (this.state.tipo_establecimiento_id === "4" ||
                        this.state.tipo_establecimiento_id === "3"))
                  ) {
                    Swal.fire({
                      title: "Error",
                      icon: "warning",
                      text: "Favor de ingresar un establecimiento de acuerdo al tipo de establecimiento actual",
                    });
                  } else {
                    let ests = this.state.establecimientos;
                    datos.asociar_id = data.id;
                    datos.asociar_tipo = data.tipo_establecimiento_id;
                    ests.push(datos);

                    this.setState({ establecimientos: ests });
                    this.asoForm.clear();
                  }
                } else {
                  Swal.fire({
                    title: "Error al ingresar el establecimiento",
                    icon: "warning",
                    text: "Favor de ingresar un establecimiento con licencia vigente.",
                  });
                }
              });
            },
          },
        },
      ],
    };

    this.asoForm = Api.form(asociaFrm);

    //Termina did mount
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/asociar-establecimiento">Asociar establecimiento</Link>
          </li>
        </ol>
        <h1 className="page-header">Asociar establecimiento</h1>
        <div className="row">
          <Panel className="col-sm-12">
            <PanelBody>
              <fieldset className="col-sm-12">
                <legend>Asociar establecimiento </legend>
                <div id="asociaForm"></div>
              </fieldset>
              <fieldset className="col-sm-12">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">ESTABLECIMIENTO</th>
                      <th className="text-center">GUID</th>
                      <th className="text-center">ESTABLECIMIENTO A ASOCIAR</th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.establecimientos.map((est, index) => (
                      <tr key={index} id={"t" + index}>
                        <td>{est.establecimientoTxt}</td>
                        <td style={{ background: "rgba(0,0,0,.3)" }}>
                          {est.guid}
                        </td>
                        <td style={{ background: "rgba(0,0,0,.3)" }}>
                          {est.razon_social}
                        </td>
                        <td align="center">
                          <button
                            id={index}
                            onClick={this.removeEst}
                            className="btn btn-warning"
                          >
                            <i
                              id={index}
                              onClick={this.removeEst}
                              className="fas fa-trash"
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <hr />
                <button
                  onClick={this.asociar}
                  className="pull-right btn btn-success"
                >
                  Asociar
                </button>
                Todos los campos marcados con{" "}
                <span style={{ color: "red" }}>*</span> son requeridos.
              </fieldset>
            </PanelBody>
          </Panel>
        </div>
      </div>
    );
  }
}

export default EstAssoc;
